import React from 'react';
import {
    f7,
    Block,
    Button,
} from 'framework7-react';

import { withTranslation } from 'react-i18next';
import {API_URL} from '../../../../../api';

class VippsCheckout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          errMgs: false
        };
    }

    updateTel(e){
        this.setState({
          errClassTel: '',
          errMgs: false
        });
    }

    render() {
        const { t } = this.props;
        return (
            <>
            {this.state.errMgs &&
            <>
            <Block className="text-color-red" style={{marginBottom:0}}>
              <p>
                {this.state.errMgs}
              </p>
            </Block>
            </>
            }
            <Block>
                <Button style={{backgroundColor:"#ff5b24"}} onClick={() => this.vippsXhr()} large raised fill>{t('checkout.pay_with_vipps')}</Button>
            </Block>
            </>
        );
    }


    vippsXhr() {
        const { t } = this.props;
        const sid = this.props.sid;
        f7.dialog.preloader(t('please_wait'));
      
        fetch(API_URL+'/payment/vipps/initiate', {
          method: 'POST',
          body: JSON.stringify({
            tid: sid
          }),
          headers : new Headers(),
        })
        .then(res => res.json())
        .then(
          (result) => {
            f7.dialog.close();
            if(result.err_code === 0){
                window.location.href = result.vipps_url;
            }else{
              this.setState({
                errMgs: result.err_mgs
              });
            }
          },
          (error) => {
            f7.dialog.close();
            this.setState({
              errMgs: t('warnings.unknown_error')
            });
          }
        )
        
      }

}

export default withTranslation()(VippsCheckout);